import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Subscription } from "rxjs";


@Component({
  selector: "[user-list-item]",
  templateUrl: "./material-type.component.html",
  styleUrls: ["./material-type.component.css"],
})
export class MaterialTypeComponent implements OnInit, OnDestroy {
  @Input() material;
  @Input() materialFormGroup: UntypedFormGroup;
  @Input() materialName;
  @Output() rowLevelValidation: EventEmitter<any> = new EventEmitter(null);
  @Input() hasRowLevelVal: Boolean;
  @Input() dependancy;

  categorysList = [];
  private readonly rowSubscription: Subscription;
  constructor() {}

  ngOnInit() {
    this.categorysList = Object.keys(this.material.category);
  }

  public getTotalGeneratedTons() {
    return this.materialFormGroup.get("totalGeneratedTons").value;
  }
  ngOnDestroy(): void {
    if (this.rowSubscription) {
      this.rowSubscription.unsubscribe();
    }
  }

}
